module.exports = __webpack_public_path__ + "static/portfolio-image-8-e561ff18aaeed70fa270596ce8b6ef5f.jpg";